import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL

// export const BASE_URL = "https://hrm-qa-ss.developerbox.co.in/"
// const API_URL = "https://hrm-qa-ss.developerbox.co.in/api"

function getBaseUrl(){
 return "https://" + window.location.host + "/api";
}


const instance: AxiosInstance = axios.create({
  // baseURL: API_URL || getBaseUrl(),
  baseURL: getBaseUrl(),
});

instance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token = localStorage.getItem("loginToken");
    const cleanedToken = token ? token.replace(/"/g, '') : null;

    if (cleanedToken) {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers["Authorization"] = `Bearer ${cleanedToken}`;
    }
    if (config.headers) {
      config.headers["Accept"] = config.headers["Accept"]
        ? config.headers["Accept"]
        : "application/json";
      config.headers["X-Requested-With"] = "XMLHttpRequest";
    }

    return config;

  },
  (error) => {
    return Promise.reject(error);
  }
);



// **Response Interceptor: Handle Errors by Status Codes**
instance.interceptors.response.use(
  (response: AxiosResponse) => response, // Pass successful responses
  (error: AxiosError) => {
    // console.log(error )

    if (error.response) {
      const { status, data } = error.response;
// console.log(status, data )
      switch (status) {
        case 400:
          console.error("Bad Request:", data?.message || "Invalid request.");
          // alert(data?.message || "Bad request. Please check your input.");
          break;

        case 401:
          console.error("Unauthorized:", data?.message || "Authentication required.");
          // alert("Session expired. Please log in again.");
          // Optional: Redirect to login page
          localStorage.clear();
          // window.location.href = "/";
          break;

        case 403:
          console.error("Forbidden:", data?.message || "You don't have permission.");
          alert("You are not authorized to perform this action.");
          break;

        case 404:
          console.error("Not Found:", data?.message || "Resource not found.");
          break;

          case 422:
            console.error("Unprocessable Entity:", data?.reason || "Validation failed.");
            const errors = data?.reason;
          
            if (typeof errors === "string") {
           
              toast.error(errors); // Directly show the string reason
            } else if (typeof errors === "object" && errors !== null) {

              Object.entries(errors).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                  toast.error(value[0]); // Show the first error message for the field
                } else {
                  // console.log("--------------------4", key, value);
                }
              });
            } else {
              toast.error("Validation failed.");
            }
            break;
          

        case 500:
          console.error("Internal Server Error:", data?.message || "Something went wrong.");
          break;

        default:
          console.error("Error:", data?.message || "An unknown error occurred.");
          break;
      }
    } else if (error.request) {
      // Request made but no response received
      console.error("No response received:", error.request);
      // alert("No response from the server. Please check your network connection.");
    } else {
      // Something else happened during the request setup
      console.error("Request Error:", error.message);
      // alert("An error occurred while setting up the request.");
    }

    return Promise.reject(error); // Reject the error to allow further handling if necessary
  }
);

export default instance;


